<template>
<div id="app" class="disclaimer page-template-default page wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="disclaimer" :gotodownload="gotodownload" :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="page type-page status-publish">
            <div class="inside-article">
              <Breadcrumbs class="page-crumb" :items="crumbs" />
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">Disclaimer</h1>
              </header>

              <div class="section-content" itemprop="text">
                <p>
                  The information on gbofficial.net is provided for general educational and informational purposes only. We share guides, version notes, feature explanations, and practical references about GB WhatsApp and related third-party app topics.
                </p>

                <h2>No Official Affiliation</h2>
                <p>
                  gbofficial.net is an independent website. We are not affiliated with, endorsed by, sponsored by, or officially connected to WhatsApp LLC, Meta Platforms, Inc., Google, Android, or any official app store.
                </p>
                <p>
                  All product names, logos, brands, and trademarks belong to their respective owners.
                </p>

                <h2>Third-Party Application Notice</h2>
                <p>
                  GB WhatsApp is a third-party modified app and is not the official WhatsApp application. Modified apps may work differently from official apps and may involve account, privacy, security, compatibility, or update risks.
                </p>
                <p>
                  We do not guarantee that any third-party app, APK file, version, feature, or external resource will be safe, available, accurate, compatible, or free from issues.
                </p>

                <h2>User Responsibility</h2>
                <p>
                  Visitors are responsible for checking their local laws, device settings, APK source, file safety, and account requirements before downloading, installing, or using any third-party app.
                </p>
                <p>
                  Always back up important chats and media before changing apps, updating APK files, or switching between official and modified WhatsApp clients.
                </p>

                <h2>External Links</h2>
                <p>
                  Our website may include links to third-party websites or resources. These links are provided for convenience and reference. We do not control third-party websites and are not responsible for their content, privacy practices, downloads, or actions.
                </p>

                <h2>Content Accuracy</h2>
                <p>
                  We try to keep information useful and current, but app features, version numbers, compatibility, and policies can change. Content may be updated, corrected, or removed without notice.
                </p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Disclaimer',
  components: {
    HeadNav,
    Breadcrumbs,
  },
  data() {
    return {
      crumbs: [
        { label: 'Home', to: '/' },
        { label: 'Disclaimer', to: '' },
      ],
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
